import { render } from "./WelcomeView.vue?vue&type=template&id=4531a9d2&scoped=true"
import script from "./WelcomeView.vue?vue&type=script&lang=js"
export * from "./WelcomeView.vue?vue&type=script&lang=js"

import "./WelcomeView.vue?vue&type=style&index=0&id=4531a9d2&scoped=true&lang=css"

import exportComponent from "/home/walnit/Documents/AppVenture/nush-bookings-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4531a9d2"]])

export default __exports__